import styled from 'styled-components'

import Tooltip from '@ilg-totallymoney/ui/icons/Tooltip'
import { focusOutlineStyle } from '@ilg-totallymoney/ui/styles/focus'
import theme from '@ilg-totallymoney/ui/theme'

const StyledTooltipButton = styled.button`
    display: inline-flex;
    align-items: center;
    padding: 0;
    background: none;
    border: 0;
    cursor: pointer;

    &:active,
    &:focus {
        ${focusOutlineStyle};
        border-radius: ${theme.radii.borderRadius05};
    }
`

interface TooltipButtonProps {
    color?: string
    onPress: () => void
    size?: number
    title: string
}

const TooltipButton = ({
    color,
    size = 20,
    onPress,
    title,
    ...props
}: TooltipButtonProps) => {
    return (
        <StyledTooltipButton {...props} onClick={() => onPress()}>
            <Tooltip size={size} color={color} title={title} />
        </StyledTooltipButton>
    )
}

export default TooltipButton
